import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

export interface IAppConfig {
  apiAuthUrl: string,
  apiSignupUrl: string,
  apiFalServices: string,
  apiValidateUrl: string,
  apiNettTracker: string,
  apiFar: string,
  apiLogging: string,
  apiHelp: string,
  isProduction: boolean,
  isStaging: boolean,
  isDevelopment: boolean,
  apiFarHost: string,
  version: string,
  oAuthCookieName: string,
  companyBlockSize: number,
}

@Injectable()
export class AppConfig {
    static settings: IAppConfig;

    constructor(private http: HttpClient) {
        let defaults = {
        //apiAuthUrl: 'http://172.31.17.253:8001/api/oAuth/',
        //apiSignupUrl: 'http://172.31.17.253:8001/api/services/signup/',
        //apiFalServices: 'http://172.31.17.253:8001/api/services/',
        //apiValidateUrl: 'http://172.31.17.253:8002/api/authorization/auth/',
        //apiNettTracker: 'http://172.31.17.253:8002/api/nettTracker/',
        //apiFar: 'http://172.31.17.253:8002/api/services/fixedAssetRegister/',
        //apiFarHost: 'https://172.31.17.253:8002/api/services',
        //apiLogging: 'http://172.31.17.253:8002/api/netttracker/loggingproxy',
        //apiHelp: 'http://172.31.17.253:8001/api/services/helpCentre',
        apiAuthUrl: 'https://api.dev.farscape-applications.com/api/oAuth/',
        apiSignupUrl: 'https://api.dev.farscape-applications.com/api/services/signup/',
        apiFalServices: 'https://api.dev.farscape-applications.com/api/services/',
        apiValidateUrl: 'https://localhost:10132/api/authorization/auth/',
        apiNettTracker: 'https://localhost:10132/api/nettTracker/',
        apiFar: 'https://localhost:10132/api/services/fixedAssetRegister/',
        apiLogging: 'https://localhost:10132/api/netttracker/loggingproxy',
        apiFarHost: 'https://localhost:10132/api/services',
        apiHelp: 'https://api.dev.farscape-applications.com/api/services/helpCentre',
        oAuthCookieName: 'OAuthRequest',
        
        isProduction: false,
        isStaging: false,
        isDevelopment: true,
        version: '2.10.dev(BE-v2)',
        companyBlockSize: 5,
        }
        AppConfig.settings = defaults;
    }

    load() {
        console.log("AppConfig is bootstrapping the app");
        return new Promise<void>((resolve, reject) => {
        this.http.get<IAppConfig>('/assets/config.json').toPromise().then((response: IAppConfig | undefined) => {
            AppConfig.settings = <IAppConfig>response;
            console.log("AppConfig bootstrap complete", response);
            resolve();
        }).catch((response: any) => {
            console.log("Unable to load configuration data from hosting server.  Defaults will be used.  Dev environment is most likely cause.", response);
            resolve();
        });
        });
    }
}
